"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _AssetFile = _interopRequireDefault(require("./AssetFile"));

var _AssetFolder = _interopRequireDefault(require("./AssetFolder"));

var _AssetImage = _interopRequireDefault(require("./AssetImage"));

var _classnames = _interopRequireDefault(require("classnames"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/asset/index.css");

  require("../../spectrum-css/asset/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/asset/index-lg.css");
} else {
  require("../../spectrum-css/asset/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/asset/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/asset/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/asset/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/asset/multiStops/darkest.css");

var Asset =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Asset, _React$Component);

  function Asset() {
    (0, _classCallCheck2["default"])(this, Asset);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Asset).apply(this, arguments));
  }

  (0, _createClass2["default"])(Asset, [{
    key: "render",
    value: function render(props) {
      var _this$props = this.props,
          type = _this$props.type,
          src = _this$props.src,
          placeholder = _this$props.placeholder,
          cache = _this$props.cache,
          headers = _this$props.headers,
          smartness = _this$props.smartness,
          alt = _this$props.alt,
          className = _this$props.className,
          onLoad = _this$props.onLoad,
          decorative = _this$props.decorative,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["type", "src", "placeholder", "cache", "headers", "smartness", "alt", "className", "onLoad", "decorative"]);
      var content;

      if (type === 'image') {
        content = _react["default"].createElement(_AssetImage["default"], {
          src: src,
          placeholder: placeholder,
          smartness: smartness,
          onLoad: onLoad,
          cache: cache,
          headers: headers,
          alt: alt,
          decorative: decorative
        });
      } else if (type === 'folder') {
        content = _react["default"].createElement(_AssetFolder["default"], {
          alt: alt,
          decorative: decorative
        });
      } else {
        content = _react["default"].createElement(_AssetFile["default"], {
          alt: alt,
          decorative: decorative
        });
      }

      return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _filterDOMProps["default"])(otherProps), {
        className: (0, _classnames["default"])('spectrum-Asset', className)
      }), content);
    }
  }]);
  return Asset;
}(_react["default"].Component);

exports["default"] = Asset;
(0, _defineProperty2["default"])(Asset, "propTypes", {
  /** Asset can be an image, folder or file type */
  type: _propTypes["default"].oneOf(['image', 'folder', 'file']),

  /** Source of the Asset if it is an image */
  src: _propTypes["default"].string,

  /** Whether to use the image cache for the asset image */
  cache: _propTypes["default"].bool,

  /** HTTP headers to add to the request for the asset image */
  headers: _propTypes["default"].object,

  /** Placeholder image to display while the fullsize one is loading, if cached. */
  placeholder: _propTypes["default"].string,

  /** A factor between 0 and 1 that controls how the preview is scaled. When 0 ("dumb") the assets fits all the space available. */
  smartness: _propTypes["default"].number,

  /** Alternate content for screen readers */
  alt: _propTypes["default"].string,

  /** Whether the image is being used for decoration and should not be announced by screen readers */
  decorative: _propTypes["default"].bool,

  /** Load callback triggered when images load */
  onLoad: _propTypes["default"].func
});
(0, _defineProperty2["default"])(Asset, "defaultProps", {
  type: 'file',
  smartness: 1
});